<template>
	<div class="row">
		<div class="d-none col-lg-4 d-lg-block pr-0" style="max-width:400px;">
			<div class="list-pengiriman">
				<div class="row">
					<div class="col align-self-center">
						<p class="mb-0"><b>Filter</b></p>
					</div>
				</div>
				<div class="form-group">
					<label for="">Tanggal Mulai & Akhir</label>
					<date-picker
						v-model="daterange_period"
						format="DD/MM/YYYY"
						type="date"
						value-type="YYYY-MM-DD"
						placeholder="Pilih Tanggal Mulai & Akhir"
						input-class="form-control"
						class="w-100"
						range
						@input="
							start_date = daterange_period[0]
							end_date   = daterange_period[1]">
					</date-picker>
				</div>
				<div class="form-group">
					<label for="">Kurir Pengiriman</label>
					<select name="" id="" class="form-control" v-model="id_merchant">
						<option value="">Pilih Kurir</option>
						<option v-for="merchant in merchants" :key="merchant.id" :value="merchant.id_user">{{merchant.col_name}}</option>
					</select>
				</div>
				<div class="form-group">
					<label for="">Rute</label>
					<select name="" id="" class="form-control" :disabled="!id_merchant" v-model="id_rute">
						<option value="">Pilih Rute</option>
						<option v-for="route in routes" :key="route.id" :value="route.id">{{route.col_rute}}</option>
					</select>
				</div>
				<button class="btn btn-primary w-100" @click="get_pengiriman()">Apply</button>
			</div>
		</div>
		<div class="col">
			<div class="detail-pengiriman">
				<p><b>Report Pengiriman</b></p>
				<div class="card" style="width: fit-content; box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.05); border-radius: 10px;" v-if="displayStartDate && displayEndDate">
					<div class="card-body p-2">
						<div class="row">
							<img src="/img/icon-calendar.png" alt="" class="ml-3">
							<p class="mb-0 align-self-center ml-2 f-14 mr-3"><b>{{ displayStartDate | moment('DD MMM YYYY') }} - {{ displayEndDate | moment('DD MMM YYYY') }}</b></p>
						</div>
					</div>
				</div>
				<div class="col mt-3">
					<div class="row">
						<div class="card mb-2 mr-3" style="width: fit-content; box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.05); border-radius: 10px;">
							<div class="card-body p-2">
								<div class="row">
									<img src="/img/icon-calendar.png" alt="" class="ml-3">
									<p class="mb-0 align-self-center ml-2 f-12 mr-3">Total Pengiriman</p>
								</div>
								<p class="mb-0 f-24 mt-2 mr-4"><b>{{ total_pengiriman | numFormat }}</b></p>
							</div>
						</div>
						<div class="card mb-2" style="width: fit-content; box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.05); border-radius: 10px;">
							<div class="card-body p-2">
								<div class="row">
									<img src="/img/icon-calendar.png" alt="" class="ml-3">
									<p class="mb-0 align-self-center ml-2 f-12 mr-3">Total Payment</p>
								</div>
								<p class="mb-0 f-24 mt-2 mr-4"><b>{{ total_harga |currency}}</b></p>
							</div>
						</div>
					</div>
				</div>
				<apexchart width="90%" type="line" height="238px" :options="lineOptions" :series="lineSeries" v-if="showLine"></apexchart>
				<hr style="border-top-style:dashed">
				<div class="table-responsive">
					<table class="table table-hover">
						<thead>
							<tr>
								<th>Tanggal</th>
								<th>Total Pengiriman</th>
								<th>Total Barang</th>
								<th>Total Harga</th>
							</tr>
						</thead>
						<tbody v-if="shippings.length >= 0">
							<tr v-for="shipping in shippings" :key="shipping.id">
								<td>{{shipping.tanggal | moment('LL')}}</td>
								<td>{{ shipping.total_pengiriman | numFormat }}</td>
								<td>{{ shipping.total_barang | numFormat }}</td>
								<td>{{ shipping.total_harga | currency }}</td>
							</tr>
							<tr v-if="shippings.length == 0">
								<td colspan="6" class="text-center">Data tidak tersedia</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="6" class="text-center">Data tidak tersedia</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			start_date: '',
			end_date: '',
			daterange_period: '',
			id_merchant: '',
			id_rute: '',

			shippings: [],
			merchants: [],
			routes: [],
			displayStartDate: null,
			displayEndDate: null,
			showLine: false,
			lineOptions: {
                chart: {
                    id: 'line-vuechart',
                },
                xaxis: {
                    categories: [],
                },
                stroke: {
                    width: 2
                },
                colors: ['#2BA379']
            },
            lineSeries: [
                {
                    name: 'Total',
                    data: [],
                }
            ],
		}
	},
	computed: {
		total_harga: function() {
			let _ = this
			let total = 0
			if (_.shippings.length > 0 ) {
				_.shippings.forEach(elm => {
					total += elm.total_harga
				});
				return total;
			}
			return total;
		},
		total_pengiriman: function() {
			let _ = this
			let total = 0
			if (_.shippings.length > 0 ) {
				_.shippings.forEach(elm => {
					total += elm.total_pengiriman
				});
				return total;
			}
			return total;
		}
	},
	methods: {
		get_pengiriman()
		{
			let _ = this
			_.axios.get('/shipment/customer-report?start_date=' + _.start_date + '&end_date=' + _.end_date + '&id_user=' + _.id_merchant + '&id_rute=' + _.id_rute)
				.then( resp => {
					_.showLine = false
					if (resp.data.data) {
						_.shippings = resp.data.data

						_.lineSeries = [
							{
								name: 'Total',
								data: [],
							}
						]

						_.lineOptions = {
							chart: {
								id: 'line-vuechart',
							},
							xaxis: {
								categories: [],
							},
							stroke: {
								width: 2
							},
							colors: ['#2BA379']
						}

						setTimeout(() => {
							_.lineOptions.xaxis.categories = _.shippings.map(x => x.tanggal)
							_.lineSeries[0].data = _.shippings.map(x => x.total_harga)
							_.showLine = true
							_.$forceUpdate()
						}, 100);
					} else {
						_.shippings = []
					}

					_.displayStartDate = JSON.parse(JSON.stringify(_.start_date))
					_.displayEndDate = JSON.parse(JSON.stringify(_.end_date))
					_.$forceUpdate()
				})
		},
		get_merchant()
		{
			let _ = this
			_.axios.get('/merchant')
				.then(resp => {
					_.merchants = resp.data.data.rows
				})
		},
		get_rute()
		{
			let _ = this
			_.axios.get('/pricelist/get_by_id_merchant?id_merchant=' + _.id_merchant)
				.then(resp => {
					_.routes = resp.data.data
				})
		}
	},
	mounted() {
		let _ = this
		_.get_pengiriman()
		_.get_merchant()
	},
	watch: {
		id_merchant: function()
		{
			this.get_rute()
			this.id_rute = ''
		},
	}
}
</script>